
import PropTypes from 'prop-types';
import { Divider, Typography, Grid, Button, LoadingButton, Stack } from '@mui/material';
import FormProvider from '../../../components/hook-form';
import Iconify from '../../../components/iconify';
import ModalPopup from '../../common/modalpopup';



// -------------------------------------------------------------------------------------------------------

CommonUserModalPopup.propTypes = {
    submitActivate: PropTypes.func,
    close: PropTypes.func,
    responseMessage: PropTypes.string,
    bodyMessage: PropTypes.string,
};

export default function CommonUserModalPopup({ submitActivate, close, responseMessage, bodyMessage }) {

    const onClickNo = () => {
        close(false);
    };
    const onClickYes = () => {
        submitActivate();
    };
    return (
        <ModalPopup sx={{
            position: 'absolute',
            top: '50%',
            left: { xs: '30%', sm: '35%', md: '38%' },
            transform: 'translateY(-50%)',
            p: 2,
            borderRadius: 1.5,
            width: { xs: 200, sm: 300, md: 380 },
            maxHeight: 570,
        }}
            cancel={onClickNo}
           // title={`Do you want to ${responseMessage}`}
            title={
                <div style={{ justifyContent: "center", alignItems: "center", display: "flex", spacing: 2, fontSize: "13px" }}>
                    <Iconify icon="ic:outline-info" color="#007bff" height="26px" width="26px" marginRight="10px" />
                    {responseMessage}
                   
                </div>
            }
        >
            
            <Divider />
            <Stack direction="row"
                justifyContent="center"
                alignItems="center"
                display="flex"
                m={2} >
                <Typography variant="contained"
                   
                >
                    {bodyMessage}
                </Typography>
            </Stack>
            <Divider />
             
                <Stack
                    direction="row"
                justifyContent="flex-end"
                    alignItems="center"
                    spacing={2}
                    mt={1}
                >
                    <Button size="small" variant="contained" onClick={onClickNo}  >
                        No
                    </Button>
                        <Button size="small" variant="contained" onClick={onClickYes}  >
                    Yes

                     </Button>
                </Stack>
        </ModalPopup>
    )
}